import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { ProjectChecklistId } from '@business/entities/project';

export class CheckListDetailPageBloc extends BaseBloc {
  private readonly checkListBloc = resolve(Blocs.checklist);

  constructor(private readonly id: ProjectChecklistId) {
    super();
  }

  loading = new LoadingState();

  readonly template$ = this.checkListBloc.selectMarketingChecklist(this.id);

  onInit() {
    return this.checkListBloc.fetchMarketingChecklist(this.id).pipe(this.loading.run());
  }

  deleteSection = this.checkListBloc.deleteChecklistSection;
  deleteSectionStep = this.checkListBloc.deleteChecklistSectionStep;
  sortSections = this.checkListBloc.sortSections;
  sortSectionSteps = this.checkListBloc.sortSectionSteps;
}
